import { styled } from '@nykaa/ui-components';
import { DWEB_ICON_BREAKPOINT } from 'shared/styles/base';
import { truncate } from 'shared/styles/mixin';

export const AuthContainer = styled.div<{ isColumn?: boolean; }>`
  display: flex;
  flex-direction: ${({ isColumn }) => (isColumn ? 'column' : 'row')};
  align-items: center;
  margin-left: ${({ theme }) => theme.spacing.spacing120};
  margin-top: ${({ theme }) => theme.spacing.spacing40};
  text-transform: capitalize;
  color: inherit;
`;

export const TextContainer = styled.div`
  width: 100%;
  ${({ theme }) => theme.typography.titleSmall};

  ${truncate}

  @media screen and (max-width: ${DWEB_ICON_BREAKPOINT}) {
    display: none;
  }
`;

export const IconWrapper = styled.span<{ isColumn?: boolean; }>`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${({ theme, isColumn }) => (isColumn ? theme.spacing.spacing0 : theme.spacing.spacing40)};
  font-size: 24px;
`;
